module.exports = __webpack_public_path__ + "img/share.5c13f1b0.jpg";